import { DateWrapper, DayText, MonthText } from './ScheduleDay.styled';

import React from 'react';
import dayjs from 'dayjs';

interface ScheduleDayProps {
  date: string;
  selectedDay: string;
  setDay: (day: string) => void;
}

export const ScheduleDay = ({ date, selectedDay, setDay }: ScheduleDayProps) => {
  const handleSetDay = () => {
    setDay(date);
  };

  return (
    <DateWrapper isSelected={selectedDay === date} onClick={handleSetDay}>
      <MonthText isSelected={selectedDay === date}>
        {dayjs(new Date(date)).format('MMM')}
      </MonthText>
      <DayText isSelected={selectedDay === date}>
        {dayjs(date).format('D')}
      </DayText>
    </DateWrapper>
  );
};
